import React, { useRef, useState, useEffect } from 'react'
import IntlTelInput from "react-intl-tel-input";
import "react-intl-tel-input/dist/main.css";
import { UTILS } from 'utils';

const PhoneNumberInput = ({
  value,
  handleChange,
  error,
  disabled,
  readOnly,
  label = "WhatsApp number",
  mandatory = false,
  placeHolder = "WhatsApp number"
}) => {

  const phoneInputRef = useRef(null);
  const [inputDisabled, setInputDisabled] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [phoneCountryObj, setPhoneCountryObj] = useState(null);

  // =====================
  // Debounce handleChange
  // =====================
  useEffect(() => {
    const timer = setTimeout(() => {
      if (handleChange && phoneNumber !== undefined && phoneNumber !== null) {
        handleChange({ phoneNumber, phoneCountryObj });
      }
    }, 300); // debounce delay

    return () => clearTimeout(timer);
  }, [phoneNumber]); // IMPORTANT: only phoneNumber as dependency


  const onChange = (isValid, phoneNumber, countryData, internationalNumber) => {
    let phone = UTILS.NumberConversion(phoneNumber);
    processPhoneNumberInput(isValid, phone, countryData, internationalNumber);
  };

  const onCountryChange = (
    phoneNumber,
    countryData,
    internationalNumber,
    isValid
  ) => {
    processPhoneNumberInput(
      isValid,
      phoneNumber,
      countryData,
      internationalNumber
    );
  };

  const setNumber = (userInput) => {
    let result = userInput?.replace(/ /g, "")?.trim();
    return result;
  };

  const processPhoneNumberInput = (
    isValid,
    phoneNumber,
    countryData,
    internationalNumber
  ) => {
    if (isValid && isValidMobileNumber(internationalNumber)) {
      checkMobileNumberHasLeadingZero(phoneNumber);
      setInputDisabled(false);
    } else {
      setPhoneNumber(setNumber(phoneNumber));
      setInputDisabled(true);
    }
    setPhoneCountryObj(countryData);
  };

  const isValidMobileNumber = (mobileNumber) => {
    const numberType = window.intlTelInputUtils.getNumberType(mobileNumber);
    return (
      numberType === window.intlTelInputUtils.numberType.FIXED_LINE_OR_MOBILE ||
      numberType === window.intlTelInputUtils.numberType.MOBILE
    );
  };

  const checkMobileNumberHasLeadingZero = (phoneNumber) => {
    if (!phoneNumber.startsWith("0")) {
      phoneNumber = "0" + phoneNumber;
      setPhoneNumber(setNumber(phoneNumber));

      const input = phoneInputRef.current?.tel;
      setTimeout(() => {
        input?.setSelectionRange(phoneNumber.length, phoneNumber.length);
      }, 0);
    } else {
      setPhoneNumber(setNumber(phoneNumber));
    }
  };


  // ==================================
  // Sync external `value` into internal
  // ==================================
  useEffect(() => {
    if (!value) return;
  
    const newNum = setNumber(value.phoneNumber);
    let newCountry = value.countryObj;
  
    let changed = false;
  
    // If country is not supplied, derive from phone number
    if (!newCountry) {
      const iti = window?.intlTelInputGlobals?.getInstance(phoneInputRef.current);
  
      if (iti && newNum) {
        const numToSet = newNum.startsWith("+") ? newNum : "+" + newNum;
        iti.setNumber(numToSet);
        newCountry = iti.getSelectedCountryData();
      }
    }
  
    if (newNum && newNum !== phoneNumber) {
      setPhoneNumber(newNum);
      changed = true;
    }
  
    if (newCountry && newCountry !== phoneCountryObj) {
      setPhoneCountryObj(newCountry);
      changed = true;
    }
  
    if (changed) setInputDisabled(false);
  
  }, [value]);
  


  return (
    <div className="flex flex-col gap-2">
      <label className="text-14x text-black">
        {label} {mandatory && <span className="text-red-500">*</span>}
      </label>

      <div dir="ltr">
        <IntlTelInput
          containerClassName="intl-tel-input intl-input-custom"
          inputClassName="intl-input-box text-16x"
          defaultCountry="ae"
          nationalMode={true}
          separateDialCode={true}
          onPhoneNumberChange={onChange}
          onSelectFlag={onCountryChange}
          disabled={disabled}
          readOnly={inputDisabled || readOnly}
          preferredCountries={[]}
          numberType="MOBILE"
          value={phoneNumber}
          placeholder={placeHolder}
          ref={phoneInputRef}
        />
      </div>

      {error && <div className="text-red-500">{error}</div>}
    </div>
  );
};

export default PhoneNumberInput;
